import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DashboardProvider } from "./context/dashboard-context";
import UserDetail from "./pages/UserDetail/UserDetail";
import ViewContract from "./pages/ViewContract/ViewContract";
import DeviceDetail from "./pages/DeviceDetail/DeviceDetail";
import Producers from "./pages/Producers/Producers";
import Notification from "./pages/Notification/Notification";
import DeviceList from "./pages/DeviceList/DeviceList";
import Organizations from "./pages/Organizations/Organizations";
import OrganizationDetail from "./pages/OrganizationDetail/OrganizationDetail";
import UserList from "./pages/UserList/UserList";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="main-wrapper">
              <App />
            </div>
          }
        />
        <Route
          path="/user-list"
          element={
            <div className="main-wrapper">
              <UserList />
            </div>
          }
        />
        <Route
          path="/user-list/:id"
          element={
            <div className="main-wrapper">
              <UserDetail />
            </div>
          }
        />
        <Route
          path="/user-detail"
          element={
            <div className="main-wrapper">
              <UserDetail />
            </div>
          }
        />
        <Route
          path="/view-contract"
          element={
            <div className="main-wrapper">
              <ViewContract />
            </div>
          }
        />
        <Route
          path="/devices"
          element={
            <div className="main-wrapper">
              <DeviceList />
            </div>
          }
        />
        <Route
          path="/devices/:id"
          element={
            <div className="main-wrapper">
              <DeviceDetail />
            </div>
          }
        />
        <Route
          path="/producers"
          element={
            <div className="main-wrapper">
              <Producers />
            </div>
          }
        />
        <Route
          path="/notification-center"
          element={
            <div className="main-wrapper">
              <Notification />
            </div>
          }
        />
        <Route
          path="/organizations"
          element={
            <div className="main-wrapper">
              <Organizations />
            </div>
          }
        />
        <Route
          path="/organizations/:id"
          element={
            <div className="main-wrapper">
              <OrganizationDetail />
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <DashboardProvider>
    <AppRoutes />
  </DashboardProvider>
);
